export default "__VITE_ASSET__PzMr0Aby__"